import { api_gateway } from '../../conexoes/api'
import decryptJWT from '../../utils/decryptJWT'

// FUNÇÃO DE ARMAZENAMENTO DOS DADOS NO MONGO
async function amostragemClickstream(rota) {
  // Salva a amostragem de dados em uma variável
  let cd_pav_usuario = 0
  let cd_pav_cliente = 0
  if (!Number.isNaN(parseInt(decryptJWT('codigo')))) {
    cd_pav_usuario = parseInt(decryptJWT('codigo'))
    cd_pav_cliente = parseInt(decryptJWT('codigoCliente'))
  }

  await api_gateway.post('/m1/servicos/usabilidade/amostragem_de_usabilidade', {
    cd_pav_usuario: cd_pav_usuario,
    cd_pav_cliente: cd_pav_cliente,
    cd_dad_acao_tipo: rota
  })
}

export default async function ColetaClickstream(rota) {
  await amostragemClickstream(rota)
}
